// ✅ FILE CREATED: src/providers/TelegramProvider.js
// REASON: Trader Journal TMA Blueprint (v1.0) - Phase 1.1
// 1. "Gating Mechanism" (တံခါးစောင့်စနစ်) ကို အကောင်အထည်ဖော်ရန်။
// 2. ဤ Provider သည် App ၏ "environment" (TMA vs Web) ကို ဆုံးဖြတ်ပေးမည့်
//    "Single Source of Truth" ဖြစ်လာမည်။
// 3. ဤ Provider ၏ "tmaStatus" state သည် အခြားသော core provider များ
//    (ဥပမာ: AuthContext) ၏ Race Condition ကို တားဆီးရန် "Gate" အဖြစ် အလုပ်လုပ်မည်။

import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';

// Context ကို ဖန်တီးခြင်း
const TelegramContext = createContext();

// Hook ကို export လုပ်ခြင်း
export const useTelegram = () => useContext(TelegramContext);

export const TelegramProvider = ({ children }) => {
    // Internal State များ
    const [tmaStatus, setTmaStatus] = useState('LOADING'); // Enum: 'LOADING', 'READY_WEB', 'READY_TMA'
    const [tmaData, setTmaData] = useState(null);
    const [tmaTheme, setTmaTheme] = useState(null);

    useEffect(() => {
        // ဤ useEffect သည် App စတင်ချိန်တွင် (၁) ကြိမ်သာ အလုပ်လုပ်မည်။
        
        // 1. Telegram WebApp object ကို ရှာဖွေပါ
        const telegramApp = window.Telegram?.WebApp;

        if (telegramApp && telegramApp.initData) {
            // --- Case 1: TMA ပတ်ဝန်းကျင် ဖြစ်သည် ---
            try {
                // TMA ကို အဆင်သင့်ဖြစ်ကြောင်း အသိပေးပါ
                telegramApp.ready();
                
                // Data များကို state ထဲသို့ သိမ်းဆည်းပါ
                setTmaData(telegramApp.initData);
                setTmaTheme(telegramApp.themeParams);
                
                // "Gate" (တံခါး) ကို ဖွင့်ပါ
                setTmaStatus('READY_TMA');
                
            } catch (error) {
                console.error("Failed to initialize Telegram WebApp:", error);
                // Error ဖြစ်ပါက Web အဖြစ် သတ်မှတ်ပါ
                setTmaStatus('READY_WEB');
            }
        } else {
            // --- Case 2: Web ပတ်ဝန်းကျင် ဖြစ်သည် ---
            // "Gate" (တံခါး) ကို ဖွင့်ပါ
            setTmaStatus('READY_WEB');
        }
        
    }, []); // dependency array (အလွတ်) ထားခြင်းဖြင့် mount တွင် (၁) ကြိမ်သာ run စေမည်။

    // မျှဝေမည့် value များ
    const value = useMemo(() => ({
        tmaStatus,
        tmaData,
        tmaTheme,
        isTMA: tmaStatus === 'READY_TMA' // (Convenience boolean)
    }), [tmaStatus, tmaData, tmaTheme]);

    return (
        <TelegramContext.Provider value={value}>
            {children}
        </TelegramContext.Provider>
    );
};
